import React, { useEffect, useState } from 'react';
import config from '../../config/config';
import Sidebar from './Sidebar';
import {
  Card,
  Col,
  Row,
  Button,
  Tabs,
  Tab,
  Modal,
  Form,
} from 'react-bootstrap';
import DashboardHeader from './directives/DashboardHeader';
import { Clipboard } from 'react-bootstrap-icons';
import './css/Dashboard.css';
import './css/Custom.css';
import {
  getLaunchProcessRequestsAction,
  getChainInfoAction,
  updateProjectListingStatusAction,
  userInvestmentAction,
  projectSubscribeAction,
} from '../../apis/apiAction';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import Web3 from 'web3';
import { Toaster, toast } from 'react-hot-toast';
import 'bootstrap/dist/css/bootstrap.min.css';

let loginWalletAddress = Cookies.get('walletAddress');

const Project = ({ special, clearModalData }) => {
  const [projectList, setProjectList] = useState([]);
  const [activeTab, setActiveTab] = useState('upcoming');

  useEffect(() => {
    getLaunchProcessRequestsAPI();
  }, []);

  const getLaunchProcessRequestsAPI = async () => {
    let res = await getLaunchProcessRequestsAction();
    if (res.status) {
      setProjectList(res.data);
    }
  };

  return (
    <>
      <Toaster />
      <div
        className="w-100 d-grid"
        style={{ minHeight: '100vh', overflow: 'hidden' }}
      >
        <div className="d-flex w-100 h-100">
          <div
            className="position-relative"
            style={{ borderRight: '1px solid rgba(255, 255, 255, 0.15)' }}
          >
            <Sidebar special={special} clearModalData={clearModalData} />
          </div>

          <div className="w-100" style={{ height: '100%' }}>
            <DashboardHeader />
            <div
              className="px-4 px-lg-4"
              style={{
                flex: '1',
                backgroundColor: '#00021F',
                color: '#ffffff',
                height: '100%',
                overflowY: 'auto',
              }}
            >
              <Row>
                <Col xxl={12}>
                  <div className="heading py-4">
                    <h5 className="mb-0">All Projects</h5>
                  </div>
                </Col>

                <Tabs
                  id="project-tabs"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className="mb-3"
                >
                  <Tab eventKey="upcoming" title="Upcoming">
                    <ProjectList
                      projectList={projectList.filter(
                        (p) =>
                          p.is_listed == 0 &&
                          p.is_active == 1 &&
                          p.is_feature == 1
                      )}
                    />
                  </Tab>
                  <Tab eventKey="listed" title="Listed">
                    <ProjectList
                      projectList={projectList.filter((p) => p.is_active == 1 && p.is_listed == 1)}
                    />
                  </Tab>
                </Tabs>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ProjectList = ({ projectList }) => {
  const [isLoading, setLoader] = useState(false);
  const [isOpenInvestModel, setIsOpenInvestModel] = useState(false);
  const [isOpenSubscribeModel, setIsOpenSubscribeModel] = useState(false);
  const [isListingId, setIsListingId] = useState();
  const [investProjectData, setInvestProjectData] = useState();
  const [userInvestAmount, setUserInvestAmount] = useState();
  const [subscribeEmail, setSubscribeEmail] = useState();

  const projectListing = async (data) => {
    console.log('dd', data);
    setIsListingId(data.id);
    try {
      if (!window.ethereum) {
        toast.error('MetaMask is not installed!');
        return;
      }

      if (!loginWalletAddress) {
        toast.error('Please connect your wallet');
        return;
      }

      const now = Math.floor(Date.now() / 1000);
      let secondsToAdd;

      const unit = data.maturityUnit?.toLowerCase();

      if (unit === 'days') {
        secondsToAdd = data.maturityPeriod * 86400;
      } else if (unit === 'months') {
        secondsToAdd = data.maturityPeriod * 30 * 86400;
      } else if (unit === 'years') {
        secondsToAdd = data.maturityPeriod * 365 * 86400;
      } else {
        throw new Error(
          "Invalid maturity unit. Must be 'days', 'months', or 'years'."
        );
      }

      const maturityPeriodInSeconds = now + secondsToAdd;

      let tokenAddress = data.tokenAddress;
      let currentPrice = data.currentPrice;
      let principal = data.principal;
      let maturityPeriod = maturityPeriodInSeconds;
      let promisedRoi = data.promisedRoi;
      let tokenDiscount = data.tokenDiscount;
      let incentiveDiscount = data.incentiveDiscount;

      if (
        !tokenAddress ||
        !currentPrice ||
        !principal ||
        !maturityPeriod ||
        !promisedRoi ||
        !tokenDiscount ||
        !incentiveDiscount
      ) {
        toast.error(
          'Please fill in all required fields: Token Address, Current Price, Principal, Maturity Period, Promised ROI, Token Discount, and Incentive Discount.'
        );
        return;
      }

      const accounts = await window.ethereum.request({
        method: 'eth_requestAccounts',
      });
      let web3 = new Web3(window.ethereum);
      let currentNetwork = web3.currentProvider.chainId;
      let chainId = data.chain;

      if (currentNetwork !== chainId) {
        toast.error('Please switch to the bnb network in MetaMask.');
        return;
      }

      let chainInfoRes = await getChainInfoAction(data.chain);
      if (chainInfoRes.status === false) {
        toast.error('Chain info not found');
        return;
      }
      let fromAccount = accounts[0];

      setLoader(true);

      // USDT Approval method calling
      const usdtApprovalHash = await usdtTokenContractApprove({
        web3,
        chainInfoRes: chainInfoRes.data,
        fromAccount,
        principal,
      });
      console.log('usdtapprovalHash', usdtApprovalHash);

      if (!usdtApprovalHash) {
        setLoader(false);
        toast.error('USDT approval failed');
        return;
      }

      // Launchpool Token Address Approval method calling
      const tokenApprovalHash = await tokenContractApprove({
        web3,
        chainInfoRes: chainInfoRes.data,
        fromAccount,
        tokenAddress,
      });

      console.log('tokenApprovalHash', tokenApprovalHash);

      if (!tokenApprovalHash) {
        setLoader(false);
        toast.error('Token approval failed');
        return;
      }

      // Launchpool project listing calling
      const projectListingHash = await projectListingOnContract({
        web3,
        fromAccount,
        tokenAddress,
        currentPrice,
        principal,
        maturityPeriod,
        promisedRoi,
        tokenDiscount,
        incentiveDiscount,
      });

      console.log('projectListingHash', projectListingHash);

      if (!projectListingHash) {
        setLoader(false);
        toast.error('Project Listing failed');
        return;
      }

      // Update project listing status
      if (usdtApprovalHash && tokenApprovalHash && projectListingHash) {
        let prjectData = {
          id: data.id,
          projectName: data.tokenName,
          usdtApprovalHash: usdtApprovalHash,
          tokenApprovalHash: tokenApprovalHash,
          projectListingHash: projectListingHash,
        };
        let listingProjectRes = await updateProjectListingStatusAction(
          prjectData
        );
        if (listingProjectRes.status) {
          toast.success(listingProjectRes.message);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          toast.error(listingProjectRes.message);
        }
      } else {
        setLoader(false);
        toast.error('Something went wrong while listing the projects.');
        return;
      }
    } catch (err) {
      setLoader(false);
      toast.error('Something went wrong while listing the projects.');
      return;
    }
  };

  const usdtTokenContractApprove = async ({
    web3,
    chainInfoRes,
    fromAccount,
    principal,
  }) => {
    try {
      if (window.ethereum) {
        const tokenContract = new web3.eth.Contract(
          config.usdContractABI,
          chainInfoRes?.usdtAddress
        );
        let decimals = await tokenContract.methods.decimals().call();
        // let allowance = await tokenContract.methods
        //   .allowance(fromAccount, chainInfoRes?.launchPoolAddress)
        //   .call();
        let amount = (principal * 10 ** parseInt(decimals)).toLocaleString(
          'fullwide',
          { useGrouping: false }
        );
        let balance = await tokenContract.methods.balanceOf(fromAccount).call();

        const approveTx = tokenContract.methods.approve(
          chainInfoRes?.launchPoolAddress,
          2 * amount
        );
        const approveEncodedTx = approveTx.encodeABI();

        let gasPrice = await web3.eth.getGasPrice();
        let gasLimit = await web3.eth.estimateGas({
          gasPrice: web3.utils.toHex(gasPrice),
          to: chainInfoRes?.usdtAddress,
          from: fromAccount,
          data: approveEncodedTx,
        });

        const trxData = await web3.eth.sendTransaction({
          gasPrice: web3.utils.toHex(gasPrice),
          gas: web3.utils.toHex(gasLimit),
          to: chainInfoRes?.usdtAddress,
          from: fromAccount,
          data: approveEncodedTx,
        });

        if (trxData.status) {
          return trxData.transactionHash;
        } else {
          return false;
        }
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const tokenContractApprove = async ({
    web3,
    chainInfoRes,
    fromAccount,
    tokenAddress,
  }) => {
    try {
      if (window.ethereum) {
        const tokenContract = new web3.eth.Contract(
          config.ERC20ABI,
          tokenAddress
        );
        let allowance = await tokenContract.methods
          .allowance(fromAccount, chainInfoRes?.launchPoolAddress)
          .call();
        let balance = await tokenContract.methods.balanceOf(fromAccount).call();

        if (Number(allowance) < Number(balance)) {
          const approveTx = tokenContract.methods.approve(
            chainInfoRes?.launchPoolAddress,
            balance
          );
          const approveEncodedTx = approveTx.encodeABI();

          let gasPrice = await web3.eth.getGasPrice();
          let gasLimit = await web3.eth.estimateGas({
            gasPrice: web3.utils.toHex(gasPrice),
            to: tokenAddress,
            from: fromAccount,
            data: approveEncodedTx,
          });

          const trxData = await web3.eth.sendTransaction({
            gasPrice: web3.utils.toHex(gasPrice),
            gas: web3.utils.toHex(gasLimit),
            to: tokenAddress,
            from: fromAccount,
            data: approveEncodedTx,
          });

          if (trxData.status) {
            return trxData.transactionHash;
          } else {
            return false;
          }
        } else {
          console.log('token already approved');
          return true;
        }
      }
    } catch (error) {
      console.log(error);
      toast.error('An error occurred during minting.');
    }
  };

  const projectListingOnContract = async ({
    web3,
    fromAccount,
    tokenAddress,
    currentPrice,
    principal,
    maturityPeriod,
    promisedRoi,
    tokenDiscount,
    incentiveDiscount,
  }) => {
    try {
      if (window.ethereum) {
        const contractAddress = new web3.eth.Contract(
          config.contractABI,
          config.contractAddress
        );

        const currentPriceInWei = web3.utils.toWei(
          currentPrice.toString(),
          'ether'
        );
        const principalInWei = web3.utils.toWei(principal.toString(), 'ether');

        console.log([
          'list',
          tokenAddress.toString(),
          currentPriceInWei.toString(),
          principalInWei.toString(),
          maturityPeriod.toString(),
          promisedRoi.toString(),
          tokenDiscount.toString(),
          incentiveDiscount.toString(),
        ]);
        const tx_builder = contractAddress.methods.listProject([
          tokenAddress.toString(),
          currentPriceInWei.toString(),
          principalInWei.toString(),
          maturityPeriod.toString(),
          promisedRoi.toString(),
          tokenDiscount.toString(),
          incentiveDiscount.toString(),
        ]);

        const encoded_tx = tx_builder.encodeABI();
        const gasPrice = await web3.eth.getGasPrice();

        const gasLimit = await web3.eth.estimateGas({
          to: config.contractAddress,
          from: fromAccount,
          data: encoded_tx,
        });

        const txDataRes = await web3.eth.sendTransaction({
          gasPrice: web3.utils.toHex(gasPrice),
          gas: web3.utils.toHex(gasLimit),
          to: config.contractAddress,
          from: fromAccount,
          data: encoded_tx,
        });

        const txHash = txDataRes.transactionHash;
        return txHash;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const openInvestModel = async (data) => {
    if (!window.ethereum) {
      toast.error('MetaMask is not installed!');
      return;
    }

    let web3 = new Web3(window.ethereum);
    let currentNetwork = web3.currentProvider.chainId;
    let chainId = data.chain;


    if (currentNetwork !== chainId) {
      toast.error('Please switch the network in MetaMask.');
      return;
    }

    const contractAddress = new web3.eth.Contract(
      config.contractABI,
      config.contractAddress
    );

    const getTokenInfo = await contractAddress.methods
      .getProjectDetails(data.tokenAddress)
      .call();
    console.log(getTokenInfo);

    let totalPrincipal = web3.utils.fromWei(getTokenInfo._principal, 'ether');
    let totalUsdtRaised = web3.utils.fromWei(getTokenInfo._usdtRaised, 'ether');

    let availableUSDTInvest =
      parseFloat(totalPrincipal) - parseFloat(totalUsdtRaised);
    data.availableUSDTInvest = availableUSDTInvest;
    setIsOpenInvestModel(true);
    setInvestProjectData(data);
  };

  const closeInvestModel = async () => {
    setIsOpenInvestModel(false);
  };

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    toast.success('Address copied to clipboard!');
  };

  const handleSubmitInvestOnProject = async (e) => {
    e.preventDefault();

    if (!userInvestAmount || userInvestAmount == 0) {
      toast.error(`Please enter USDT amount`);
      return;
    }

    if (
      parseFloat(userInvestAmount) >
      parseFloat(investProjectData.availableUSDTInvest)
    ) {
      toast.error(
        `You can invest maximum ${investProjectData.availableUSDTInvest} USDT`
      );
      return;
    }

    let web3 = new Web3(window.ethereum);
    let currentNetwork = web3.currentProvider.chainId;
    let chainId = investProjectData.chain;

    if (currentNetwork !== chainId) {
      toast.error('Please switch the network in MetaMask.');
      return;
    }

    try {
      const accounts = await window.ethereum.request({
        method: 'eth_requestAccounts',
      });
      let fromAccount = accounts[0];

      let chainInfoRes = await getChainInfoAction(investProjectData.chain);
      if (chainInfoRes.status === false) {
        toast.error('Chain info not found');
        return;
      }
      setLoader(true);
      // USDT Approval method calling
      console.log('inv', userInvestAmount);
      const usdtApprovalHash = await usdtTokenContractApproveForInvest({
        web3,
        chainInfoRes: chainInfoRes.data,
        fromAccount,
        userInvestAmount,
      });
      console.log('approvalHash', usdtApprovalHash);

      if (!usdtApprovalHash) {
        setLoader(false);
        toast.error('USDT approval failed');
        return;
      }

      const contractAddress = new web3.eth.Contract(
        config.contractABI,
        config.contractAddress
      );

      const investAmount = web3.utils.toWei(
        userInvestAmount.toString(),
        'ether'
      );

      const tx_builder = contractAddress.methods.invest(
        investProjectData.tokenAddress.toString(),
        investAmount
      );
      const encoded_tx = tx_builder.encodeABI();
      const gasPrice = await web3.eth.getGasPrice();

      const gasLimit = await web3.eth.estimateGas({
        to: config.contractAddress,
        from: fromAccount,
        data: encoded_tx,
      });

      const txDataRes = await web3.eth.sendTransaction({
        gasPrice: web3.utils.toHex(gasPrice),
        gas: web3.utils.toHex(gasLimit),
        to: config.contractAddress,
        from: fromAccount,
        data: encoded_tx,
      });

      const trxHash = txDataRes.transactionHash;
      if (trxHash) {
        let investmentData = {
          projectId: investProjectData.id,
          walletAddress: fromAccount,
          usdtAmount: userInvestAmount,
          trxHash: trxHash,
        };
        let investRes = await userInvestmentAction(investmentData);
        if (investRes.status) {
          toast.success(investRes.msg);
          setTimeout(() => {
            window.location.href = `${config.baseUrl}dashboard`;
          }, 2000);
        } else {
          toast.error(investRes.msg);
          return;
        }
      } else {
        setLoader(false);
        toast.error('Something went wrong please try again after some time.');
        return;
      }
    } catch (error) {
      console.log('err', error);
      setLoader(false);
      toast.error('Something went wrong please try again after some time.');
    }
  };

  const usdtTokenContractApproveForInvest = async ({
    web3,
    chainInfoRes,
    fromAccount,
    userInvestAmount,
  }) => {
    try {
      if (window.ethereum) {
        const tokenContract = new web3.eth.Contract(
          config.usdContractABI,
          chainInfoRes?.usdtAddress
        );
        let decimals = await tokenContract.methods.decimals().call();
        let amount = (
          userInvestAmount *
          10 ** parseInt(decimals)
        ).toLocaleString('fullwide', { useGrouping: false });

        let balance = await tokenContract.methods.balanceOf(fromAccount).call();

        const approveTx = tokenContract.methods.approve(
          chainInfoRes?.launchPoolAddress,
          amount
        );
        const approveEncodedTx = approveTx.encodeABI();

        let gasPrice = await web3.eth.getGasPrice();
        let gasLimit = await web3.eth.estimateGas({
          gasPrice: web3.utils.toHex(gasPrice),
          to: chainInfoRes?.usdtAddress,
          from: fromAccount,
          data: approveEncodedTx,
        });

        const trxData = await web3.eth.sendTransaction({
          gasPrice: web3.utils.toHex(gasPrice),
          gas: web3.utils.toHex(gasLimit),
          to: chainInfoRes?.usdtAddress,
          from: fromAccount,
          data: approveEncodedTx,
        });

        if (trxData.status) {
          return trxData.transactionHash;
        } else {
          return false;
        }
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const openSubscriberModel = async (data) => {
    setInvestProjectData(data);
    setIsOpenSubscribeModel(true);
  };

  const closeSubscriberModel = async () => {
    setIsOpenSubscribeModel(false);
    setSubscribeEmail('');
  };

  const handleSubmitProjectSubscribe = async (e) => {
    e.preventDefault();

    if (!subscribeEmail) {
      toast.error(`Please enter email address`);
      return;
    }

    let res = await projectSubscribeAction({
      email: subscribeEmail,
      walletAddress: loginWalletAddress,
      projectId: investProjectData.id,
    });

    if (res.status) {
      toast.success(res.msg);
      setIsOpenSubscribeModel(false);
      setSubscribeEmail('');
    } else {
      toast.error(res.msg);
      return;
    }
  };

  return projectList.length > 0 ? (
    <>
      <Row>
        {projectList.map((data) => (
          <Col
            xxl={4}
            xl={5}
            lg={12}
            md={12}
            sm={12}
            className="mb-4"
            key={data.id}
          >
            <Card className="dashboard-card dash-gradient2 p-3 d-flex overflow-hidden gap-3 bg-blue">
              <div className="bgshape position-absolute top-0 bottom-0 start-0 end-0 w-100 h-100">
                <img
                  src="assets/images/shape/boxshade.png"
                  className="w-100 h-100 object-fit-cover"
                  alt="Background Shape"
                />
              </div>
              <Card.Body className="p-0 position-relative">
                <h4 className="text-white">{data.tokenName}</h4>
                <div className="my-3">
                  <InfoRow label="Total Supply" value={data.totalSupply} />
                  <InfoRow label="ROI" value={`${data.promisedRoi}%`} />
                  <InfoRow label="USDT To Raise" value={data.principal} />
                  <InfoRow label="Chain" value={data.chainName} />
                </div>
                <div className="d-flex gap-3">
                  <Button
                    as={Link}
                    to={`${config.baseUrl}projectoverview/${btoa(
                      data.id.toString()
                    )}`}
                    variant="primary-gradient"
                    className="w-100 border-0 px-md-1 small"
                  >
                    View Details
                  </Button>

                  {loginWalletAddress !== data.walletAddress &&
                    data.is_listed === 0 && (
                      <Button
                        variant="primary-gradient"
                        className="w-100 border-0 px-md-1 small"
                        onClick={() => openSubscriberModel(data)}
                      >
                        Subscribe
                      </Button>
                    )}

                  {loginWalletAddress === data.walletAddress &&
                    data.is_listed == 0 &&
                    (isLoading && data.id === isListingId ? (
                      <Button
                        variant="outline-blue"
                        className="w-100 px-md-1 small"
                      >
                        Processing{' '}
                        <img
                          src={`${config.baseUrl}assets/images/loader.gif`}
                          width="20px"
                        />
                      </Button>
                    ) : (
                      <Button
                        variant="outline-blue"
                        className="w-100 px-md-1 small"
                        onClick={() => projectListing(data)}
                      >
                        List
                      </Button>
                    ))}

                  {data.is_listed == 1 &&
                    (isLoading && data.id === isListingId ? (
                      <Button
                        variant="outline-blue"
                        className="w-100 px-md-1 small"
                      >
                        Processing{' '}
                        <img
                          src={`${config.baseUrl}assets/images/loader.gif`}
                          width="20px"
                        />
                      </Button>
                    ) : (
                      <Button
                        variant="outline-blue"
                        className="w-100 px-md-1 small"
                        onClick={() => openInvestModel(data)}
                      >
                        Invest
                      </Button>
                    ))}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Project investment popup  */}
      <Modal
        show={isOpenInvestModel}
        onHide={closeInvestModel}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: '#000' }}>Invest</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmitInvestOnProject}>
          <Modal.Body>
            <div className="mt-5">
              <p>
                <strong>Token Name: </strong> {investProjectData?.tokenName}
              </p>
              <p>
                <strong>Token Address: </strong>{' '}
                {investProjectData?.tokenAddress.slice(0, 6)}......
                {investProjectData?.tokenAddress.slice(-5)}
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => handleCopy(investProjectData?.tokenAddress)}
                  style={{ marginLeft: '10px', padding: '0 8px' }}
                  title="Copy address"
                >
                  <Clipboard size={16} />
                </Button>
              </p>

              <p>
                <strong>Available USDT To Invest: </strong> $
                {investProjectData?.availableUSDTInvest}
              </p>

              <Form.Group>
                <Form.Label>USDT Amount</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter USDT Amount"
                  onKeyPress={(event) => {
                    if (!/^\d*[.]?\d{0,1}$/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={userInvestAmount}
                  onChange={(e) => setUserInvestAmount(e.target.value)}
                  required
                />
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {isLoading ? (
              <Button type="button" variant="primary-gradient">
                Processing{' '}
                <img
                  src={`${config.baseUrl}assets/images/loader.gif`}
                  width="20px"
                />
              </Button>
            ) : (
              <Button type="submit" variant="primary-gradient">
                Submit
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Subscribe / Get update  */}
      <Modal
        show={isOpenSubscribeModel}
        onHide={closeSubscriberModel}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: '#000' }}>Subscribe </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmitProjectSubscribe}>
          <Modal.Body>
            <div className="mt-5">
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter email address"
                  value={subscribeEmail}
                  onChange={(e) => setSubscribeEmail(e.target.value)}
                  required
                />
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {isLoading ? (
              <Button type="button" variant="primary-gradient">
                Processing{' '}
                <img
                  src={`${config.baseUrl}assets/images/loader.gif`}
                  width="20px"
                />
              </Button>
            ) : (
              <Button type="submit" variant="primary-gradient">
                Submit
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  ) : (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100px' }}
    >
      <strong>No Data Found!</strong>
    </div>
  );
};

const InfoRow = ({ label, value }) => (
  <div className="d-flex justify-content-between">
    <div className="mb-2 text-light-grey small">{label}</div>
    <div className="mb-2 text-white small">{value}</div>
  </div>
);

export default Project;
